export const postmanDataset = {
      "name": "CLIENT-LINK-ARTAPAY",
      "item": [
        {
          "name": "DGPC",
          "item": [
            {
              "name": "POST DGPC VA",
              "request": {
                "method": "POST",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "{\r\n    \"trxId\": \"tes-16\",\r\n    \"amount\": \"10000\",\r\n    \"serviceId\": \"4\",\r\n    \"expiredTime\": \"20\",\r\n    \"partnerServiceId\": \"19008\",\r\n    \"customerNo\": \"9\",\r\n    \"channel\": \"BCA\",\r\n    \"trxTypeIdx\": \"0\",\r\n    \"virtualAccountName\": \"hendra\",\r\n    \"virtualAccountEmail\": \"hendradrakho@gmail.com\",\r\n    \"virtualAccountPhone\": \"082122782522\"\r\n}",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/va",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "va"
                  ]
                }
              },
              "response": []
            },
            {
              "name": "GET DGPC VA",
              "protocolProfileBehavior": {
                "disableBodyPruning": true
              },
              "request": {
                "method": "GET",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/va/tes-16",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "va",
                    "tes-16"
                  ]
                }
              },
              "response": []
            },
            {
              "name": "PUT DGPC VA",
              "request": {
                "method": "PUT",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "{\r\n    \"amount\": \"11000\",\r\n    \"serviceId\": \"4\",\r\n    \"expiredTime\": \"25\",\r\n    \"trxTypeIdx\": \"0\"\r\n}",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/va/tes-16",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "va",
                    "tes-16"
                  ]
                }
              },
              "response": []
            },
            {
              "name": "DELETE DGPC VA",
              "request": {
                "method": "DELETE",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/va/tes-16",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "va",
                    "tes-16"
                  ]
                }
              },
              "response": []
            }
          ]
        },
        {
          "name": "TRANSFER FEE",
          "item": [
            {
              "name": "CALLBACK",
              "item": [
                {
                  "name": "DOKU CALLBACK UNPAID",
                  "request": {
                    "method": "POST",
                    "header": [
                      {
                        "key": "Client-Id",
                        "value": " BRN-0233-1776445447654",
                        "type": "text"
                      },
                      {
                        "key": "Request-Id",
                        "value": " ee453c5c-e077-427f-a2a6-be0c20bc418f",
                        "type": "text"
                      },
                      {
                        "key": "Request-Timestamp",
                        "value": " 2026-06-11T01:06:39Z",
                        "type": "text"
                      },
                      {
                        "key": "Signature",
                        "value": " HMACSHA256=YZocDQv5VrrFF8mpj7/oaO0Fo20UI6UobTyBea6++34=",
                        "type": "text"
                      },
                      {
                        "key": "Content-Type",
                        "value": " application/json",
                        "type": "text"
                      }
                    ],
                    "body": {
                      "mode": "raw",
                      "raw": "{\r\n  \"sendTrxId\": \"TF-BILL-1782284846637\",\r\n  \"transactionId\": \"TF-BILL-1782284846637\",\r\n  \"invoiceNumber\": \"I088787987870912\",\r\n  \"transactionStatus\": \"50\",\r\n  \"activityCode\": \"200\",\r\n  \"message\": \"Transaction is Success\",\r\n  \"processDate\": \"2024-01-12'T'07:30:12\",\r\n  \"createdTime\": \"1699520040340\"\r\n}",
                      "options": {
                        "raw": {
                          "language": "json"
                        }
                      }
                    },
                    "url": {
                      "raw": "{{host}}/doku/transfer/unpaid",
                      "host": [
                        "{{host}}"
                      ],
                      "path": [
                        "doku",
                        "transfer",
                        "unpaid"
                      ]
                    }
                  },
                  "response": []
                },
                {
                  "name": "DOKU CALLBACK REFUND",
                  "request": {
                    "method": "POST",
                    "header": [
                      {
                        "key": "Client-Id",
                        "value": " BRN-0233-1776445447654",
                        "type": "text"
                      },
                      {
                        "key": "Request-Id",
                        "value": " ee453c5c-e077-427f-a2a6-be0c20bc418f",
                        "type": "text"
                      },
                      {
                        "key": "Request-Timestamp",
                        "value": " 2026-06-11T01:06:39Z",
                        "type": "text"
                      },
                      {
                        "key": "Signature",
                        "value": " HMACSHA256=YZocDQv5VrrFF8mpj7/oaO0Fo20UI6UobTyBea6++34=",
                        "type": "text"
                      },
                      {
                        "key": "Content-Type",
                        "value": " application/json",
                        "type": "text"
                      }
                    ],
                    "body": {
                      "mode": "raw",
                      "raw": "{\r\n  \"transactionId\": \"TF-BILL-1782284846637\",\r\n  \"activityCode\": \"200\",\r\n  \"message\": \"Transaction is Refunded\",\r\n  \"processDate\": \"2024-01-12'T'07:30:12\"\r\n}",
                      "options": {
                        "raw": {
                          "language": "json"
                        }
                      }
                    },
                    "url": {
                      "raw": "{{host}}/doku/transfer/refund",
                      "host": [
                        "{{host}}"
                      ],
                      "path": [
                        "doku",
                        "transfer",
                        "refund"
                      ]
                    }
                  },
                  "response": []
                }
              ]
            },
            {
              "name": "TRANSFER FEE OTP",
              "request": {
                "method": "POST",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "{\r\n  \"serviceId\" : \"4\"\r\n}",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/payment-vendor/transfer/otp",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "payment-vendor",
                    "transfer",
                    "otp"
                  ]
                }
              },
              "response": []
            },
            {
              "name": "TRANSFER FEE",
              "request": {
                "method": "POST",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "{\r\n    \"serviceId\" : \"4\",\r\n    \"usrIdentifier\": \"4:1789032232821:1789032232821\",\r\n        \"key\": \"4:1789032232821:1789032232821b:bs09sklq1ntgb76j\",\r\n        \"otp\": \"79421341\",\r\n    \"name\": \"nina amelia\",\r\n    \"amount\": \"2300000\",\r\n    \"bankName\": \"BANK BCA\",\r\n    \"bankNumber\": \"122192992\",\r\n    \"ktp\": \"1219291929292922\",\r\n    \"customerNumber\": \"081727272721\",\r\n    \"firstName\": \"hendra\",\r\n    \"lastName\": \"dra\"\r\n}",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/payment-vendor/transfer",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "payment-vendor",
                    "transfer"
                  ]
                }
              },
              "response": []
            }
          ]
        },
        {
          "name": "QRIS",
          "item": [
            {
              "name": "CALLBACK",
              "item": [
                {
                  "name": "DOKU CALLBACK QRIS",
                  "request": {
                    "method": "POST",
                    "header": [
                      {
                        "key": "Client-Id",
                        "value": " BRN-0233-1776445447654",
                        "type": "text"
                      },
                      {
                        "key": "Request-Id",
                        "value": " ee453c5c-e077-427f-a2a6-be0c20bc418f",
                        "type": "text"
                      },
                      {
                        "key": "Request-Timestamp",
                        "value": " 2026-06-11T01:06:39Z",
                        "type": "text"
                      },
                      {
                        "key": "Signature",
                        "value": " HMACSHA256=YZocDQv5VrrFF8mpj7/oaO0Fo20UI6UobTyBea6++34=",
                        "type": "text"
                      },
                      {
                        "key": "Content-Type",
                        "value": " application/json",
                        "type": "text"
                      }
                    ],
                    "body": {
                      "mode": "raw",
                      "raw": "{\r\n  \"service\": {\r\n    \"id\": \"QRIS\",\r\n    \"name\": \"QRIS\"\r\n  },\r\n  \"acquirer\": {\r\n    \"id\": \"93600899\",\r\n    \"name\": \"DOKU\"\r\n  },\r\n  \"issuer\": {\r\n    \"id\": \"93600915\",\r\n    \"name\": \"Dana\"\r\n  },\r\n  \"channel\": {\r\n    \"id\": \"QRIS_DOKU\",\r\n    \"name\": \"QRIS-DOKU\"\r\n  },\r\n  \"customer\": {\r\n    \"doku_id\": \"9360091537851662965\",\r\n    \"name\": \"MA******************          \",\r\n    \"email\": \"QR1.Info@artamedianet.co.id\",\r\n    \"phone\": \"6285268820111\"\r\n  },\r\n  \"merchant\": {\r\n    \"name\": \"GOODNET\",\r\n    \"pan\": \"936008990000095148\"\r\n  },\r\n  \"order\": {\r\n    \"invoice_number\": \"ARTABILL0012-1780518601713\",\r\n    \"amount\": 113220.00,\r\n    \"tips\": 0.00,\r\n    \"terminal_id\": \"A10             \"\r\n  },\r\n  \"emoney_payment\": {\r\n    \"account_id\": \"\",\r\n    \"approval_code\": \"1pb9vc681946\"\r\n  },\r\n  \"transaction\": {\r\n    \"status\": \"SUCCESS\",\r\n    \"date\": \"2026-06-10T13:08:05Z\",\r\n    \"original_request_id\": \"1781096770991\"\r\n  },\r\n  \"additional_info\": {\r\n    \"postalCode\": \"33290\",\r\n    \"feeType\": \"1\"\r\n  }\r\n}",
                      "options": {
                        "raw": {
                          "language": "json"
                        }
                      }
                    },
                    "url": {
                      "raw": "{{host}}/doku/callback/qris",
                      "host": [
                        "{{host}}"
                      ],
                      "path": [
                        "doku",
                        "callback",
                        "qris"
                      ]
                    }
                  },
                  "response": []
                },
                {
                  "name": "DOKU REFUND QRIS",
                  "request": {
                    "method": "POST",
                    "header": [],
                    "body": {
                      "mode": "raw",
                      "raw": "{\r\n  \"partnerServiceId\": \"  888994\",\r\n  \"customerNo\": \"00000000000000000001\",\r\n  \"virtualAccountNo\": \"  88899400000000000000000001\",\r\n  \"virtualAccountName\": \"Toru Yamashita\",\r\n  \"trxId\": \"ARTABILL0009-1776332387115\",\r\n  \"paymentRequestId\": \"12839218738127830\",\r\n  \"paidAmount\": {\r\n    \"value\": \"11500.00\",\r\n    \"currency\": \"IDR\"\r\n  },\r\n  \"totalAmount\": {\r\n    \"value\": \"11500.00\",\r\n    \"currency\": \"IDR\"\r\n  },\r\n  \"virtualAccountEmail\": \"toru@oor.com\",\r\n  \"virtualAccountPhone\": \"081293912081\",\r\n  \"additionalInfo\": {\r\n    \"channel\": \"VIRTUAL_ACCOUNT_BANK_MANDIRI\"\r\n  },\r\n  \"trxDateTime\": \"2023-01-01T10:55:00+07:00\"\r\n}",
                      "options": {
                        "raw": {
                          "language": "json"
                        }
                      }
                    },
                    "url": {
                      "raw": "{{host}}/doku/refund/qris",
                      "host": [
                        "{{host}}"
                      ],
                      "path": [
                        "doku",
                        "refund",
                        "qris"
                      ]
                    }
                  },
                  "response": []
                }
              ]
            },
            {
              "name": "DOKU GENERATE QRIS",
              "request": {
                "method": "POST",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "{\r\n  \"partnerReferenceNo\": \"JournalArta-1783563279523\",\r\n  \"merchantId\": \"0039\",\r\n  \"amount\": 10000,\r\n  \"expiredTime\": 60\r\n}",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/qris",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "qris"
                  ]
                }
              },
              "response": []
            },
            {
              "name": "DOKU GET GENERATED QRIS",
              "protocolProfileBehavior": {
                "disableBodyPruning": true
              },
              "request": {
                "method": "GET",
                "header": [
                  {
                    "key": "content-type",
                    "value": "application/json",
                    "type": "text"
                  },
                  {
                    "key": "Authorization",
                    "value": "{{PaymentGatewayToken}}",
                    "type": "text"
                  }
                ],
                "body": {
                  "mode": "raw",
                  "raw": "",
                  "options": {
                    "raw": {
                      "language": "json"
                    }
                  }
                },
                "url": {
                  "raw": "{{host}}/snap/generate/qris/JournalArta-1783563279523",
                  "host": [
                    "{{host}}"
                  ],
                  "path": [
                    "snap",
                    "generate",
                    "qris",
                    "JournalArta-1783563279523"
                  ]
                }
              },
              "response": []
            }
          ]
        }
      ]
    }